// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.4142 22H2V2H22V16.4142L16.4142 22ZM15.5 15.5V20L20 15.5H15.5ZM18 10V8H6V10H18ZM11 14V12H6V14H11Z"}}]};

const StickyNoteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sticky-note-filled',
    ref,
    icon: element,
  },
));

StickyNoteFilledIcon.displayName = 'StickyNoteFilledIcon';

export default StickyNoteFilledIcon;
